import axios from 'axios';
import { setupInterceptors } from '../../../services/api/client/interceptors';
import type { SheetsSettings, PreviewResponse, CommitResult } from '../types';

const SHEETS_API_URL =
  process.env.REACT_APP_SHEETS_API_URL ||
  'https://0yigbwxly7.execute-api.ap-south-1.amazonaws.com';

const api = axios.create({
  baseURL: SHEETS_API_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
});
setupInterceptors(api);

export async function getSheetsSettings(): Promise<SheetsSettings> {
  const res = await api.get('/settings/sheets');
  return (res.data.data ?? res.data) as SheetsSettings;
}

export async function updateSheetsSettings(settings: SheetsSettings): Promise<void> {
  const { spreadsheets, tab_name_format, status_map } = settings;
  await api.put('/settings/sheets', { spreadsheets, tab_name_format, status_map });
}

export async function previewSheetsSync(spreadsheetId: string): Promise<PreviewResponse> {
  const res = await api.post('/sheets/sync/preview', { spreadsheetId });
  return (res.data.data ?? res.data) as PreviewResponse;
}

export async function commitSheetsSync(
  spreadsheetId: string,
  tabName: string,
  approvedRows: number[],
): Promise<CommitResult> {
  const res = await api.post('/sheets/sync/commit', { spreadsheetId, tabName, approvedRows });
  return (res.data.data ?? res.data) as CommitResult;
}
